import { jsx } from "react/jsx-runtime";
import { Alert } from "@zillow/constellation";
import { dynamic } from "@zillow/frontier/dynamic";
import { remote } from "@zillow/frontier/import";
import { useBlockEnvironment } from "@zillow/zrs-cms";
let frontierBlocks = {};
function setFrontierBlocksRegistry(registry) {
  frontierBlocks = registry;
}
function createFrontierBlock(blockName, remoteModule) {
  if (!blockName.includes("/")) {
    throw new Error('Block name must include a namespace (e.g., "cms-frontier/blockname" or "custom-namespace/block-name")');
  }
  let blockMetadata = null;
  let RemoteComponent = null;
  const createDynamicComponent = () => {
    return dynamic(async () => {
      try {
        return await remote(remoteModule, {
          onError: ({
            error
          }) => {
            console.error(`[Frontier] Remote module "${remoteModule}" failed to load:`, error);
            return {
              default: () => null
            };
          }
        });
      } catch (err) {
        console.error(`[Frontier] Unexpected error loading "${remoteModule}":`, err);
        return {
          default: () => null
        };
      }
    }, {
      render: "ssr",
      type: "remote",
      module: remoteModule,
      webpack: () => [require.resolve("@zillow/frontier/dynamic"), remoteModule]
    });
  };
  const BlockComponent = (props) => {
    const {
      environment
    } = useBlockEnvironment();
    if (environment === "editor") {
      return /* @__PURE__ */ jsx(Alert, { body: (blockMetadata == null ? void 0 : blockMetadata.editorPlaceholder) || `Editor placeholder for ${blockName}` });
    }
    if (!RemoteComponent) {
      return null;
    }
    return /* @__PURE__ */ jsx(RemoteComponent, { ...props });
  };
  const getBlockData = async (block) => {
    try {
      const mod = await remote(remoteModule, {
        onError: ({
          error
        }) => {
          console.error(`[Frontier] getBlockData: remote "${remoteModule}" failed:`, error);
          return {};
        }
      });
      if (typeof mod.getBlockData === "function") {
        return await mod.getBlockData(block);
      }
    } catch (error) {
      console.error(`[Frontier] Error loading getBlockData for ${blockName}:`, error);
    }
    return null;
  };
  const blockExport = {
    BLOCK_NAME: blockName,
    metadata: blockMetadata,
    register(registry) {
      registry[blockName] = {
        Component: BlockComponent,
        metadata: blockMetadata,
        getBlockData,
        updateMetadata: (newMetadata) => {
          blockMetadata = {
            ...newMetadata,
            name: blockName,
            // Always preserve block name
            remoteModule
            // Always preserve remote module
          };
          if (registry[blockName]) {
            registry[blockName].metadata = blockMetadata;
          }
        }
      };
    },
    updateMetadata(newMetadata) {
      blockMetadata = {
        ...newMetadata,
        name: blockName,
        // Always preserve block name
        remoteModule
        // Always preserve remote module
      };
      if (frontierBlocks[blockName] && frontierBlocks[blockName].updateMetadata) {
        frontierBlocks[blockName].updateMetadata(newMetadata);
      }
    },
    initBlock() {
      RemoteComponent = createDynamicComponent();
    }
  };
  blockExport.register(frontierBlocks);
  blockExport.initBlock();
  if (frontierBlocks[blockName]) {
    frontierBlocks[blockName].initBlock = blockExport.initBlock;
  }
  return blockExport;
}
export {
  createFrontierBlock,
  setFrontierBlocksRegistry
};
